import { Component, OnInit } from '@angular/core';
import {ActionSheetController, NavParams, PopoverController} from '@ionic/angular';
import { PtyWsService } from '../../services/pty-ws.service';
import { PtyLdService } from '../../services/pty-ld.service';
import * as moment from 'moment-timezone';
import {TranslationService} from "../../services/translation.service";

@Component({
    selector: 'app-seeker-profile-discipleship',
    templateUrl: './seeker-profile-discipleship.component.html',
    styleUrls: ['./seeker-profile-discipleship.component.scss'],
})
export class SeekerProfileDiscipleshipComponent implements OnInit {
    systemLanguages: any = [];
    systemCommunities: any = [];
    seeker: any;
    profileInfo: any = {};
    info: any;
    slides: any = null;
    new_time_line_item: any = null;
    spritualGrowthChnages: any = [];
    preferences: any = {
        seeker_name: '',
        seeker: {
            created_at_human: null,
            name: null,
        },
        conversation: {
            assigned_to: 'Unassigned',
            usual_time_available: '13:00 - 19:00',
            average_respond_time: '30 minutes'
        },
        prefs: {
            what_can_i_be: null
        },
        social: {
            preferred: ['facebook', 'google', 'viber']
        },
        discipleship: {
            salvation: false,
            holy_spirit: '',
            church: '',
            bible: '',
            prayer: '',
            look_to_jesus: '',
            next_steps: '',
        }
    };

    constructor(
        private popCtrl: PopoverController,
        private ws: PtyWsService,
        private ld: PtyLdService,
        private navParams: NavParams,
        private actSheet: ActionSheetController,
        private _translationService: TranslationService
    ) {
        this.info = this.navParams.get('event');
    }

    ngOnInit() {
        this.loadSeekerProfile();
    }

    saveDiscipleship() {
        this.popCtrl.dismiss();
    }

    loadSeekerProfile() {
        const self = this;
        self.ld.showLoading(true, {}).then(() => {
            self.ws.invokeURL('seeker_profile', { seeker_uuid: this.info.seeker_uuid }).subscribe((result: any) => {
                if (result.error === 0) {
                    self.systemLanguages = result.languages;
                    self.systemCommunities = result.communities;
                    self.ld.showLoading(false);
                    if (result.rows.length > 0) {
                        self.seeker = result.rows[0];
                        this.profileInfo.preferences = { ...self.preferences, ...self.seeker.preferences };
                        this.profileInfo.preferences.seeker.created_at_human = moment(self.seeker.created_at).format('YYYY-MM-DD HH:mm');
                        // tslint:disable-next-line: max-line-length
                        this.profileInfo.preferences.conversation.assigned_to = self.seeker.om_first_name + ' ' + self.seeker.om_last_name + ' (' + self.seeker.om_username + ')';
                        self.preferences = { ...self.preferences, ...self.seeker.preferences };
                        this.profileInfo.preferences.seeker_name = self.seeker.name;
                        result.rows[0].timeline.forEach((el) => {
                            el.date_from = moment(el.created_at).fromNow();
                        });
                    }
                    setTimeout(() => {
                        self.slides.updateAutoHeight();
                    }, 250)
                } else {
                    self.ld.showLoading(false, { message: result.message });
                }
            }, (err: any) => {
                console.error('Error loading seeker profile', err);
                self.ld.showLoading(false, { message: this._translationService.translate('UnknownError') });
            });
        });
    }

    saveProfile() {
        const self = this;
        self.ld.showLoading(true).then(() => {
            self.ws.invokeURL('seeker_save_profile', {
                seeker_uuid: this.info.seeker_uuid,
                preferences: this.preferences,
                seeker: this.profileInfo
            }).subscribe((result: any) => {
                if (result.error === 0) {
                    this.timeLineMessage();
                    this.dismiss();
                    if((result.message).trim() === 'Saved Successfully.'){
                        self.ld.showLoading(false,{message: this._translationService.translate('SavedSuccessfully')});
                    } else {
                        self.ld.showLoading(false)
                    }
                    
                } else {
                    self.ld.showLoading(false, { message: result.message });
                }
            }, (err: any) => {
                console.error('Error saving seeker profile', err);
                self.ld.showLoading(false, { message: this._translationService.translate('UnknownError') });
            });
        });
    }

    timeLineMessage() {
        let message: any = this._translationService.translate('FieldsUpdated');
        this.spritualGrowthChnages.forEach((e: any) => {
            message += '<br/>' + e.field + ':<br/>' + e.value + '\n';
        });
        this.addTimelineItem(message);
    }

    addTimelineItem(message) {
        const self = this;
        self.ws.invokeURL('seeker_timeline', {
            seeker_uuid: self.seeker.uuid,
            note: message,
            action: 'add'
        }).subscribe((result: any) => {
            if (result.error === 0) {
                self.new_time_line_item = result;
            } else {
                // console.log(result);
            }
        }, (err: any) => {
            console.error('Error saving seekers note', err);
        });
    }

    async dismiss() {
        await this.popCtrl.dismiss();
    }

    spirtualGrowthChnages(field, event) {
        const index = this.spritualGrowthChnages.findIndex(y => y.field === field);
        if (index > -1) {
            this.spritualGrowthChnages.splice(index, 1);
        }
        this.spritualGrowthChnages.push({ 'field': field, 'value': event });
    }

    async checkDataChange() {
        if (this.spritualGrowthChnages.length > 0) {
            this.showConfirm();
        } else {
            this.dismiss()
        }
    }

    async showConfirm() {
        const actionSheet = await this.actSheet.create({
            // header: this._translationService.translate('Confirmation'),
            buttons: [{
                text: this._translationService.translate('Save'),
                icon: 'save',
                handler: () => {
                    this.saveProfile();
                }
            }, {
                text: this._translationService.translate('Cancel'),
                icon: 'close',
                role: 'cancel',
                handler: () => {
                    this.dismiss();
                }
            }],
            backdropDismiss: false,
            header: this._translationService.translate('UnsavedChanges'),
            subHeader: "Do you want to Save the changes or Cancel?"
        });
        await actionSheet.present();
    }

}
